import { getBoundingBoxFromFlatCoords } from './bounding-box';

function coordinatesToFeature( coordinates: Array<Array<number>> ): any {
    return {
        type: 'Feature',
        bbox: getBoundingBoxFromFlatCoords( coordinates ),
        geometry: {
            type: 'Polygon',
            coordinates: coordinates,
        },
        properties: {},
    };
}

export {
    coordinatesToFeature,
};
